<div *ngIf="isVisible">
	<ul class="dropdown-menu">
		<li (click)="selectItem(i)" *ngFor="let item of items; let i = index">
			{{ item.fileName }}
		</li>
	</ul>
</div>
